export default class TaskLogger {
  onChange(tasks) {
    console.log(tasks._tasks);
  }
}



// WEBPACK FOOTER //
// ./src/listener/TaskLogger.js